// -----------------------------------------------------------
// FloraIQ - Processing3DStagePanel (Aba Etapa 4 - Processamento 3D)
// -----------------------------------------------------------

import { processing3DData } from "@/mocks/operational";

const statusColors: Record<string, string> = {
  "Processado": "bg-green-100 text-green-700",
  "Validado": "bg-green-100 text-green-700",
  "Em processamento": "bg-accent-100 text-accent-700",
  "Aguardando processamento": "bg-orange-100 text-orange-700",
  "Com erro": "bg-red-100 text-red-700",
  "Reprocessar": "bg-yellow-100 text-yellow-700",
};

export default function Processing3DStagePanel() {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        {/* Tabela principal */}
        <div className="lg:col-span-2 rounded-card border border-background-200/70 p-4">
          <h4 className="text-sm font-bold text-foreground-900 mb-3">Processamento de Nuvens de Pontos</h4>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/50">
                  <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Levantamento</th>
                  <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Status</th>
                  <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Pontos</th>
                  <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Árvores</th>
                  <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Alturas</th>
                  <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Copas</th>
                  <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Interf.</th>
                  <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Qualidade</th>
                </tr>
              </thead>
              <tbody>
                {processing3DData.map((p) => (
                  <tr key={p.id} className="border-b border-background-100/70 hover:bg-background-50/50">
                    <td className="px-2 py-2 text-xs font-medium text-foreground-800">{p.levantamento}</td>
                    <td className="px-2 py-2">
                      <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${statusColors[p.status] || "bg-background-100 text-foreground-600"}`}>
                        {p.status}
                      </span>
                    </td>
                    <td className="px-2 py-2 text-xs text-foreground-600">{p.pontosProcessados > 0 ? (p.pontosProcessados / 1_000_000).toFixed(0) + "M" : "-"}</td>
                    <td className="px-2 py-2 text-xs text-foreground-600">{p.arvoresVinculadas > 0 ? p.arvoresVinculadas.toLocaleString("pt-BR") : "-"}</td>
                    <td className="px-2 py-2 text-xs text-foreground-600">{p.alturasExtraidas > 0 ? p.alturasExtraidas.toLocaleString("pt-BR") : "-"}</td>
                    <td className="px-2 py-2 text-xs text-foreground-600">{p.copasEstimadas > 0 ? p.copasEstimadas.toLocaleString("pt-BR") : "-"}</td>
                    <td className="px-2 py-2 text-xs text-foreground-600">{p.interferenciasDetectadas > 0 ? p.interferenciasDetectadas : "-"}</td>
                    <td className="px-2 py-2">
                      {p.qualidade > 0 ? (
                        <div className="flex items-center gap-1.5">
                          <div className="w-10 bg-background-100 rounded-full h-1">
                            <div className={`h-1 rounded-full ${p.qualidade >= 90 ? "bg-green-500" : p.qualidade >= 80 ? "bg-accent-500" : "bg-orange-500"}`} style={{ width: `${p.qualidade}%` }}></div>
                          </div>
                          <span className="text-[10px] text-foreground-600">{p.qualidade}%</span>
                        </div>
                      ) : <span className="text-[10px] text-foreground-400">-</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Painel de métricas */}
        <div className="space-y-4">
          <div className="rounded-card border border-background-200/70 p-4">
            <h4 className="text-sm font-bold text-foreground-900 mb-3">Painel de Métricas 3D</h4>
            <div className="space-y-2.5">
              {[
                { label: "Altura Extraída", value: "6.930 árvores", icon: "ri-arrow-up-line", ok: true },
                { label: "Diâmetro de Copa", value: "5.716 árvores", icon: "ri-focus-3-line", ok: true },
                { label: "Área de Copa", value: "Média 28,4 m²", icon: "ri-landscape-line", ok: true },
                { label: "Volume de Copa", value: "Média 142 m³", icon: "ri-shapes-line", ok: true },
                { label: "Inclinação Média", value: "3,2°", icon: "ri-contrast-line", ok: true },
                { label: "Divergência Campo x 3D", value: "438 árvores (6,3%)", icon: "ri-alert-line", ok: false },
                { label: "Confiança Média", value: "87%", icon: "ri-check-double-line", ok: true },
              ].map((m) => (
                <div key={m.label} className="flex items-center gap-2.5 p-2 rounded-lg bg-background-50/70">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${m.ok ? "bg-green-100" : "bg-orange-100"}`}>
                    <i className={`${m.icon} ${m.ok ? "text-green-600" : "text-orange-600"} text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-700">{m.label}</p>
                    <p className="text-[10px] font-medium text-foreground-900">{m.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}